import { BModal, BFormGroup, BFormInput, VBModal } from "bootstrap-vue";

export default {
  components: {
    BModal,
    BFormGroup,
    BFormInput,
  },
  directives: {
    "b-modal": VBModal,
  },
  props: {
    type: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      disabled: false,
      form: {
        title: "",
        min_value: 0,
        max_value: 0,
        bon_value: 0,
        score_value: 0,
      },
    };
  },
  methods: {
    async createPurchaseScore() {
      this.disabled = true;
      try {
        let formData = new FormData();
        formData.append("title", this.form.title);
        formData.append("type", this.type);
        formData.append("min_value", this.form.min_value);
        formData.append("max_value", this.form.max_value);
        formData.append("bon_value", this.form.bon_value);
        formData.append("score_value", this.form.score_value);

        const response = await this.$axios.post(
          `admin/customers_club/add_purchase_score`,
          formData
        );
        this.$root.notify(response.data.message, "success");
        this.$root.$emit("bv::hide::modal", `create_purchase_score`);
        this.$emit("after-add-score", response.data.data.list);
        this.form.title = "";
        this.form.min_value = 0;
        this.form.max_value = 0;
        this.form.bon_value = 0;
        this.form.score_value = 0;
      } catch (error) {
        this.$root.notify(error);
      } finally {
        this.disabled = false;
      }
    },
  },
};